module.exports = __webpack_public_path__ + "bg_fourth.jpg?bd329c187b40418cf363c990a384c82a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_fourth.jpg
// module id = 8
// module chunks = 0